import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';
import { Layout } from "../../ui/layout";
import { ButtonComponent } from "../../ui/molecules/button/newButton";
import { MadfarmInput } from "../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { Pagination } from "../../ui/organisms/pagination";
import { activityOptions, normativa, regioniList, status } from "../../utils";
import { SOTFilter } from "../sot";
import { ListingPersonale } from "./list";
import { GetAllPersonalManagement, PMCreation, resetFilters, resetPersonalManagementCreationStatus, setActiveFilter, setFunctionFilter, setNormFilter, setPageFilter, setRegionFilter, setSotFilter, setSurnameFilter } from "./slice";

export function GestionePersonale() {

    const PMState = useAppSelector(state => state.personalManagement)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [activeStatusFilter, setActiveStatusFilter] = useState<'active' | 'inactive' | null>(null);

    useEffect(() => {
        if (PMState.personalManagementCreationStatus === 'successfully') {
            dispatch(resetPersonalManagementCreationStatus())
            dispatch(GetAllPersonalManagement(PMState.filters))
            navigate('/nuovoPersonale')
        }
    }, [PMState.personalManagementCreationStatus])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_PERSONALE}
            breadcrumbItems={['Gestione Personale']}
            noPaddingLat
            headerLabel="Gestione Personale"
            headerChildren={
                <div className="flex items-center h-full w-full justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Aggiungi Personale"
                        color={"orange"}
                        onClick={() => {
                            dispatch(PMCreation())
                        }}
                    />
                </div>
            }
        >
            <div className="flex flex-col min-w-0 p-6">
                <div className="flex items-center gap-2">
                    <div className="flex flex-row items-center gap-2 w-full">
                        <div className="w-[25%]">
                            <MadfarmInput
                                placeholder="Cerca per cognome"
                                value={PMState.filters.surname ?? ''}
                                onChangeText={(text) => { dispatch(setSurnameFilter(text)) }
                                }
                            />
                        </div>
                        <div className="w-[75%] flex flex-row gap-2 items-center">
                            <SOTFilter
                                value={PMState.filters.headQuarter}
                                onChange={(value) => {
                                    dispatch(setSotFilter(value))
                                }}
                            />
                            <MadfarmStaticSelect
                                isClearable
                                noOptionsMessage="Nessuna regione trovata"
                                placeholder={'Regione'}
                                options={regioniList}
                                value={PMState.filters.region ?? null}
                                onChange={(value) => {
                                    // @ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setRegionFilter(newValue))
                                }}
                            />
                            <MadfarmStaticSelect
                                isClearable
                                noOptionsMessage="Nessuna norma trovata"
                                placeholder={'Norma'}
                                options={normativa}
                                value={PMState.filters.norm ?? null}
                                onChange={(value) => {
                                    // @ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setNormFilter(newValue))
                                }}
                            />
                            <MadfarmStaticSelect
                                isClearable
                                noOptionsMessage="Nessuna funzione trovata"
                                placeholder={'Funzione'}
                                options={activityOptions}
                                value={PMState.filters.function ?? null}
                                onChange={(value) => {
                                    // @ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setFunctionFilter(newValue))
                                }}
                            />
                            <MadfarmStaticSelect
                                isClearable
                                noOptionsMessage="Nessuno stato trovato"
                                placeholder={'Stato'}
                                options={status}
                                value={activeStatusFilter}
                                onChange={(value) => {
                                    // @ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setActiveFilter(newValue === 'active' ? true : newValue === 'inactive' ? false : undefined))
                                    if (newValue === 'active' || newValue === 'inactive') {
                                        setActiveStatusFilter(newValue)
                                        return
                                    }
                                    setActiveStatusFilter(null)
                                }}
                            />
                        </div>
                    </div>
                    <div className="flex flex-row gap-2 items-center">
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Pulisci"
                            color={"gray"}
                            onClick={
                                () => {
                                    setActiveStatusFilter(null)
                                    dispatch(resetFilters())
                                }
                            }
                            fullWidth
                        />
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Cerca"
                            color={"orange"}
                            onClick={() => {
                                dispatch(setPageFilter(0))
                                dispatch(GetAllPersonalManagement({ ...PMState.filters, page: 0 }))
                            }}
                            fullWidth
                        />
                    </div>
                </div>

                <div className="flex justify-end">
                    <Pagination
                        numbResults={PMState.getAllPersonalManagementResourcesResponse?.total || 0}
                        pages={PMState.getAllPersonalManagementResourcesResponse?.totalPage || 1}
                        currentPage={PMState.filters.page || 0}
                        setPage={
                            (page) => {
                                dispatch(setPageFilter(page))
                                dispatch(GetAllPersonalManagement({ ...PMState.filters, page }))
                            }
                        }

                    />
                </div>

                <ListingPersonale />
            </div>

        </Layout>
    )
}